

import React, { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Typography,
  Button,
  IconButton,
  TextField,
  Box,
  Breadcrumbs,
  Autocomplete,
  useMediaQuery,
  InputAdornment,
  Link,Tooltip,Tabs, Tab,
} from "@mui/material";

import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { Branchdata, Industrydata, sampleData } from "../../components/grid/GridData";
import { externalgetApi } from "../../services/externalApis";
import { SETTING_API_01, SETTING_API_04, SETTING_API_11 } from "../../api/ApiModel";
import ViewDataGrid from "../../components/grid/ViewDataGrid";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import { PageDataContext } from "../../utils/common/PageDataContext";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation } from "react-router-dom";
import CreateBranch from "./CreateBranch";
function ViewBranch() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);
  const SYS_USER = useSelector((state) => state.user) || {};
  const {    LOCCODE,STAFFMAPLOCODE, COMPCODE, } = SYS_USER.USER_PARAM || {};
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const { selectedItem } = location.state || {};
  const [data, setData] = useState(null);
  const [error, setError] = useState({});
   const [filteredRows, setFilteredRows] = useState([]);
    const [searchQuery, setSearchQuery] = useState(""); // State for search input
  useEffect(() => {
    setPageData({
      title: "Bank Branch",
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);

 const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const [compbankcode, setCompbankcode] = useState(selectedItem?.compbankcode || "");

useEffect(() => {
  if (selectedItem?.compbankcode) {
    setCompbankcode(selectedItem.compbankcode);
  }
}, [selectedItem]);

  const handleItemClick = (id, actionText) => {
    if (actionText === "Edit") {
      const selectedItem = data.find((item) => item.compbankbranchcode === id);
      if (selectedItem) {
        navigate(`/createBranch`, { state: { selectedItem, actionText, compbankcode } });
      }
    }
    };
  
    const menuItems = [
      {
        text: "Edit",
        icon: <BorderColorOutlinedIcon />,
      onClick: (compbankbranchcode) => handleItemClick(compbankbranchcode, "Edit"),
      },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
      const result = await externalgetApi(SETTING_API_11, "get", {
     
COMPBANKCODE: selectedItem.compbankcode || compbankcode,
          STS: CON_STATUS_ACTIVE,
        });

        setData(result);
        setFilteredRows(result);
      console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [selectedItem?.compbankcode,compbankcode]);

  // Handle search input change
  const handleSearchChange = (event, value) => {
    setSearchQuery(value); // Update search query state

    // Filter rows based on search query
    const filtered = data?.filter((row) =>
      row.branchname.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredRows(filtered || []);
  };


const addToView = () => {
  navigate("/createBranch", { state: { compbankcode } });
};
    const goBackToView = () => {
    navigate("/vCreateBanks");
  };

  return (
    <>
      <Box sx={styles.box_breadcrumb}>
          <Tooltip title="Back to All Items" arrow sx={styles.breadcrumb_tooltip}>
                  <IconButton
                    aria-label="back"
                    sx={styles.btn_breadcrumb_back}
                    onClick={goBackToView}
                  >
                    <ArrowBackIcon sx={styles.btn_breadcrumb_back_icon} />
                  </IconButton>
                </Tooltip>
     <Breadcrumbs
                 separator="›"
                 aria-label="breadcrumb"
                 sx={styles.breadcrumb}
               >
                 <Link
                   underline="hover"
                   sx={styles.breadcrumb_link}
                   // href=""
                 >
                   Home
                 </Link>
                 <Link
                   sx={styles.breadcrumb_link}
                   underline="hover"
                   // href=""
                 >
                   Settings
                 </Link>
                 <Link
                   sx={styles.breadcrumb_link_page}
                   underline="hover"
                   // href="#"
                   aria-current="page"
                 >
                  Branch
                 </Link>
               </Breadcrumbs>
      </Box>
  
 
   
        <>
    

      <Box sx={styles.box_page_container}>
        <AppBar sx={styles.appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              item
              size={{ xs: 12, sm: 12, md: 6, lg: 8, xl: 8 }}
              sx={styles.appbar_grid_container_col_1}
            >

              <Typography sx={styles.appbar_title}>
                {Branchdata.name} : {selectedItem.bankname}
              </Typography>
            </Grid>

            <Grid
              item
              size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}
              sx={styles.appbar_grid_search}
            >
              <Autocomplete
                              freeSolo
                              id="sample-search"
                              fullWidth
                              disableClearable
                              value={searchQuery}
                              onInputChange={handleSearchChange} // Handle search input change
                              sx={styles.ipt_appbar_search_auto}
                              options={data?.map((row) => row.branchname) || []} // Provide options for autocomplete
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Search by..."
                                  size="small"
                                  sx={styles.ipt_appbar_search}
                                  InputProps={{
                                    ...params.InputProps,
                                    type: "search",
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton sx={styles.btn_appbar_search_icon}>
                                          <SearchIcon />
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              )}
                            />

              <Button
                variant="contained"
                startIcon={<AddCircleOutlineIcon />}
                size="small"
                sx={{ ...styles.btn_primary, ...styles.btn_appbar_add }}
                onClick={addToView}
              >
                Add
              </Button>
            </Grid>
          </Grid>
        </AppBar>

        <Box sx={styles.view_page_container}>
        <ViewDataGrid
  columns={Branchdata.columns}
  rows={filteredRows.map((row) => ({
    ...row,
    id: row.compbankbranchcode || Math.random(),
  }))} // Ensure each row has a unique id
  getRowId={(row) => row.id} // Use the id property for unique identification
  isLoading={isLoading}
  menuItems={menuItems}
  tabletitle={Branchdata.name}
  gridid="compbankbranchcode"
  sx={styles.view_data_grid_page}
/>
        </Box>
      </Box>
      </>
     
        
    </>
  );
}
export default ViewBranch;
